import React from 'react';
import withView from '../../../../cmn/docAutomation/withView';
import FormLauncher from '../../../../cmn/docAutomation/FormLauncher';
import useViewSwitcher from '../../../../../library/hooks/switch/useViewSwitcher'
import SarasViewSwitch from '../../../../../library/hooks/switch/SarasViewSwitch';
import SarasTabsSwitch from '../../../../../library/repeater/tabs/SarasTabsSwitch'
import FormDialog from '../../../../../library/form/components/FormDialog';
import SarasTrans from "../../../../../library/notifications/SarasTrans";
import prodViewMap from '../../Index'

import { UiForm } from "../../../../../library/layout/Index";
import FormWrapper from '../../../../../library/form/components/FormWrapper';

const ProdTaskReturn = (props) => {
    const { viewMap, formObject, viewData, viewSwitcher, ...restProps } = props;
    const rmViewSwitcher = useViewSwitcher("ISMA");

    const issueGroups = [
        { key: "ISMA", val: "Material", isDefault: 1 },
        { key: "output", val: "Output" }
    ]

    return (
        <FormDialog onDynamicViewClose={restProps.onDynamicViewClose} enablePopup={true} formObject={formObject}
            action={{ 
                formActions: { forAction: "Confirm", forCancel: "Cancel", confirmAction:"Are you sure to Confirm ?", confirmCancel:"Are you sure to Cancel ?" }, 
                actionParam: {actionType:"returnMaterial", pathKey:"TRET"} }}
            formStyle={{ width: '950px', height: '650px' }}
            contentStyle={{ height: '450px' }}
            formTitle={<SarasTrans value='Return Material' />}
            >
            <UiForm formName="issueHeader">
                <FormLauncher viewMap={prodViewMap} viewSwitcher={rmViewSwitcher} compositionKey="returnHeader" viewData={viewData} {...restProps}></FormLauncher>
            </UiForm>
            <FormWrapper formObject={formObject} rowKey="" action={{ paramName: "ioContainer" }} >
                <SarasTabsSwitch viewSwitcher={rmViewSwitcher} switches={issueGroups} kscStartAt={1} />
                <SarasViewSwitch viewSwitcher={rmViewSwitcher} ctrlKey='ISMA' hideMode='soft' >
                    <UiForm formName="returnInput">
                        <FormLauncher viewMap={prodViewMap} viewSwitcher={rmViewSwitcher} compositionKey="returnInput" viewData={viewData} {...restProps}></FormLauncher>
                    </UiForm>
                </SarasViewSwitch>
                <SarasViewSwitch viewSwitcher={rmViewSwitcher} ctrlKey='output' hideMode='soft' >
                    <UiForm formName="returnOutput">
                        <FormLauncher viewMap={prodViewMap} viewSwitcher={rmViewSwitcher} compositionKey="returnOutput" viewData={viewData} {...restProps}></FormLauncher>
                    </UiForm>
                </SarasViewSwitch>
            </FormWrapper>
            <UiForm formName="returnAudit">
                <FormLauncher viewMap={prodViewMap} viewSwitcher={rmViewSwitcher} compositionKey="returnAudit" viewData={viewData} {...restProps}></FormLauncher>
            </UiForm>
        </FormDialog>
    )
}

export default withView(ProdTaskReturn, "prodTaskReturn", "prodTask,prodTaskList");